var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.09579 4.0674C8.15438 8.13454 0.861897 9.77321 0.0713775 4.0674C0.0420775 1.35899e-05 7.30526 -1.63866 8.09579 4.0674Z",
    fill: "#193666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81597 4.61689C5.78667 4.49995 5.90386 3.68061 5.75738 3.24189C5.5816 3.03681 5.25933 2.71503 4.87896 2.36396C4.20513 2.30537 3.29693 2.27631 2.44781 2.36396C2.27203 3.24189 2.33062 4.85079 2.41851 5.67012C3.5313 5.81636 4.14654 5.81636 5.81597 5.67012V5.31904V5.37764V4.61689ZM4.08795 5.11445C4.02936 5.11445 3.85406 5.11445 3.70758 4.99751C3.5611 4.85103 3.4439 4.61689 3.53179 4.38301C3.59038 4.17818 3.79546 4.03169 4.02984 4.03169C4.23492 4.03169 4.44 4.14888 4.49859 4.35371C4.58648 4.49995 4.61578 4.70478 4.49859 4.88032C4.3814 5.1147 4.11725 5.11445 4.08795 5.11445ZM4.61529 3.35884C4.43951 3.38814 3.76617 3.35884 2.79937 3.35884V2.77363C3.32671 2.74433 3.5611 2.77363 4.5567 2.77363C4.586 2.83222 4.586 2.80294 4.64459 2.89058C4.6153 3.06613 4.67389 3.00753 4.61529 3.35884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.8175ce8af9942db68c5b2b31153b4c1a.svg";
export { ForwardRef as ReactComponent };